import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { Box, CircularProgress, Typography } from "@mui/material";
import { Check, PriorityHigh } from "@mui/icons-material";

import MDBox from "@vendor/components/MDBox";
import { BasicLayout } from "@shared/ui/auth/BasicLayout";
import bgImage from "@assets/images/bg-sign-up-cover.jpeg";
import Coderland from "@assets/images/logos/logo.png";
import { setLayout, useMaterialUIController } from "@vendor/context";
import { STORAGE_KEYS } from "@shared/constants/storageKeys";
import { chargeHourPublic } from "../api/timeEntryApi";
import { ChargeHourForm } from "../components/ChargeHourForm";

export const ChargeHourPublicPage = () => {
  localStorage.setItem(STORAGE_KEYS.TOKEN, "");
  const [open, setOpen] = useState(false);
  const { id, token, projectName, localDate, type } = useParams();
  const [error, setError] = useState(false);
  const [, dispatch] = useMaterialUIController();

  const ShowIcons = () => {
    if (!open && !error) {
      return (
        <>
          <Check color="success" fontSize="large" />
          <Typography>Tus horas fueron cargadas con exito</Typography>
        </>
      );
    }
    if (!open && error) {
      return (
        <>
          <PriorityHigh color="error" fontSize="large" />
          <Typography>Este link ya fue utilizado</Typography>
        </>
      );
    }
    return <></>;
  };

  useEffect(() => {
    setLayout(dispatch, "pages");
  }, []);

  // Si el tipo es "Automatic", carga las horas directamente sin mostrar formulario.
  useEffect(() => {
    if (type === "Automatic") {
      setOpen(true);
      const request = { id, token, projectName, localDate, type };
      chargeHourPublic(request)
        .then(() => setOpen(false))
        .catch(() => {
          setOpen(false);
          setError(true);
        });
    }
  }, [type]);

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          bgColor="black"
          borderRadius="lg"
          coloredShadow="grey"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <Grid container spacing={2} sx={{ justifyContent: "center", mt: 1, mb: 2 }}>
            <img alt="Logo Coderland" src={Coderland} height="90%" width="90%" />
          </Grid>
        </MDBox>
        {type === "Automatic" ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "300px",
            }}
          >
            {open && (
              <>
                <CircularProgress />
                <Typography>Cargando...</Typography>
              </>
            )}
            <ShowIcons />
          </Box>
        ) : (
          <ChargeHourForm />
        )}
      </Card>
    </BasicLayout>
  );
};
